/**
 * Returns the visible Topic categories in their authored order.
 *
 * The legacy `category` field remains the fallback for Topics created before
 * structured classification was introduced. Structured primary and secondary
 * categories otherwise form the complete Hero presentation.
 */
export function topicCategoryLabels(category: unknown, classification: unknown): string[] {
	const labels = classificationCategories(classification);
	if (labels.length) return labels;
	const fallback = cleanLabel(category);
	return fallback ? [fallback] : [];
}

function classificationCategories(classification: unknown): string[] {
	if (!isRecord(classification)) return [];
	const categories = [classification.primaryCategory, ...(Array.isArray(classification.secondaryCategories) ? classification.secondaryCategories : [])];
	const seen = new Set<string>();
	return categories.flatMap((candidate) => {
		const label = isRecord(candidate) ? cleanLabel(candidate.label) : undefined;
		if (!label || seen.has(label)) return [];
		seen.add(label);
		return [label];
	});
}

function cleanLabel(value: unknown): string | undefined {
	return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

function isRecord(value: unknown): value is Record<string, unknown> {
	return Boolean(value) && typeof value === 'object';
}
